import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { connect } from 'react-redux';

import ShipperOrderCard from 'modules/shipper-order/Card';

import { getShipperOrderDetailData } from 'redux/modules/shipper-order-detail/selectors';

import { CardsContainerStyled } from 'modules/detail/styled';

const ShipperOrderInfo = ({ shipperOrder, fetching }) => {
  if (fetching || !shipperOrder) {
    return null;
  }

  return (
    <CardsContainerStyled>
      <ShipperOrderCard fullWidth shipperOrder={shipperOrder} showHeader={false} />
    </CardsContainerStyled>
  );
};

ShipperOrderInfo.propTypes = {
  item: PropTypes.object,
};

export default injectIntl(
  connect((state, props) => {
    return {
      shipperOrder: getShipperOrderDetailData(state),
    };
  }, {})(ShipperOrderInfo)
);
